import {TextField} from "@mui/material";
import {forwardRef} from "react";

const CustomInput = forwardRef(({
                                 placeholder,
                                 size,
                                 fullWidth,
                                 style,
                                 id,
                                 type,
                                 defaulValue,
                                 value,
                                 variant,
                                 disabled,
                                 ...props
                              }: any, ref) => {

   return (
      <TextField
         disabled={disabled}
         value={value}
         variant={variant}
         type={type}
         id={id}
         placeholder={placeholder}
         size={size}
         fullWidth={fullWidth}
         style={style}
         {...props}
         ref={ref}
         defaultValue={defaulValue}
      />
   )
})
export default CustomInput;
